import LocalizedStrings from "react-localization"

export const strings = new LocalizedStrings({
  en: {
    old_link: "https://events.redcross.fi/",
    time: "Time",
    event: "Event",
    location: "Location",
    signups: "Signups",
    sign_in: "Sign in",
    email: "Email address",
    password: "Password",
    sign_in_button: "Sign in",
    logout: "Log out",
    to_list: "List view",
    to_calendar: "Calendar view",
    today: "Today",
    month: "Month",
    week: "Week",
    day: "Day",
    do_signup: "Sign up",
    event_details: "Details",
    signed_up: "Signups",
    owner_group: "Owner",
    name: "Name",
    coming: "Coming",
    not_coming: "Not coming",
    start_time: "Start Time",
    end_time: "End Time",
    comments: "Comments",
    confirmed: "Confirmed",
    confirm: "Confirm",
    leader: "Leader",
    trainee: "Trainee",
    food_available: "Food available",
    food_notavailable: "No food available",
    contact: "Contact person",
    to_old_hupsis: "To old Hupsis",
    next_event: "Your next event",
    next_practice: "Your next practice",
    mileage: "Mileage",
    explanation: "Travel explanation",
    add_to_calendar: "Add to calendar",
    log_entry: "Log entry",
    log_entries: "Log entries",
    add_log_entry: "Add log entry",
    sex: "Sex",
    male: "Male",
    female: "Female",
    sex_other: "Other",
    wont_tell: "Won't tell",
    age: "Age",
    adult: "Adult",
    youth: "Youth",
    child: "Child",
    reason: "Reason",
    reason_detail: "Details",
    firstaid: "Firstaid",
    future_steps: "Future steps",
    next_step: "Next step",
    medicine_ok: "No medicine contraindication",
    form_written: "Form",
    other_notes: "Notes",
    usage: "Usage",
    log_user: "User",
    log_time: "Time",
    event_log_entry: "Event Log",
    event_log_entries: "Event Log Entries",
    add_event_log_entry: "Add Event Log",
    entry: "Entry",
    entry_number: "Entry number",
    close: "Close",
    save: "Save",
    group: "Group",
    filter: "Filter",
    all: "All",
    events: "Events",
    practices: "Practices",
    trainings: "Trainings",
    others: "Others",
    event_admin: "Admin",
    send_message: "Send message",
    message_subject: "Message subject",
    default_message_subject: "Hupsis - Information about",
    add_attachments: "Add attachments",
    all_signedup: "All signed up",
    all_confirmed: "All confirmed",
    all_nonconfirmed: "All non-confirmed",
    operation_code: "Operation code",
    team_id: "Team ID",
  },
  fi: {
    old_link: "https://paivystykset.punainenristi.fi/",
    time: "Aika",
    event: "Tapahtuma",
    location: "Sijainti",
    signups: "Osallistujat",
    sign_in: "Kirjaudu sisään",
    email: "Sähköpostiosoite",
    password: "Salasana",
    sign_in_button: "Kirjaudu",
    logout: "Kirjaudu ulos",
    to_list: "Listanäkymä",
    to_calendar: "Kalenterinäkymä",
    today: "Tänään",
    month: "Kuukausi",
    week: "Viikko",
    day: "Päivä",
    do_signup: "Ilmoittaudu",
    event_details: "Lisätiedot",
    signed_up: "Ilmoittautumiset",
    owner_group: "Vastuuryhmä",
    name: "Nimi",
    coming: "Tulen",
    not_coming: "En pääse",
    start_time: "Alkuaika",
    end_time: "Loppuaika",
    comments: "Kommentit",
    confirmed: "Vahvistettu",
    confirm: "Vahvista",
    leader: "Johtaja",
    trainee: "Harjoittelija",
    food_available: "Ruokailu järjestetty",
    food_notavailable: "Ruokailua ei järjestetty",
    contact: "Yhdyshenkilö",
    to_old_hupsis: "Vanhaan Hupsikseen",
    next_event: "Seuraava päivystyksesi",
    next_practice: "Seuraava ryhmäiltasi",
    mileage: "Matkakulut",
    explanation: "Matkaselvitys",
    add_to_calendar: "Lisää kalenteriin",
    log_entry: "Asiakaskirjaus",
    log_entries: "Asiakaskirjaukset",
    add_log_entry: "Lisää asiakaskirjaus",
    sex: "Sukupuoli",
    male: "Mies",
    female: "Nainen",
    sex_other: "Muu",
    wont_tell: "Ei kerro",
    age: "Ikä",
    adult: "Aikuinen",
    youth: "Nuori",
    child: "Lapsi",
    reason: "Tulosyy",
    reason_detail: "Tarkenne",
    firstaid: "Ensiapu",
    future_steps: "Kotihoito-ohjeet",
    next_step: "Jatkohoito",
    medicine_ok: "Ei estettä lääkkeelle",
    form_written: "Saate",
    other_notes: "Muuta",
    usage: "Tarvikkeet",
    log_user: "Kirjaaja",
    log_time: "Aika",
    event_log_entry: "Tapahtumakirjaus",
    event_log_entries: "Tapahtumakirjaukset",
    add_event_log_entry: "Lisää tapahtumakirjaus",
    entry: "Kirjaus",
    entry_number: "Asiakas nro",
    close: "Sulje",
    save: "Talleta",
    group: "Ryhmä",
    filter: "Suodata",
    all: "Kaikki",
    events: "Päivystykset",
    practices: "Ryhmäillat",
    trainings: "Koulutukset",
    others: "Muut",
    event_admin: "Hallinta",
    send_message: "Lähetä viesti",
    message_subject: "Viestin otsikko",
    default_message_subject: "Hupsis - Lisätietoviesti tapahtumasta",
    add_attachments: "Lisää liitetiedostoja",
    all_signedup: "Kaikille ilmoittautuneille",
    all_confirmed: "vahvistetuille",
    all_nonconfirmed: "vahvistamattomille",
    operation_code: "Operaatiokoodi",
    team_id: "Partion nimi",
  },
  sv: {
    old_link: "https://dejour.rodakorset.fi/",
    time: "Tid",
    event: "Namn",
    location: "Plats",
    signups: "Osallistujat",
    sign_in: "Logga in",
    email: "Sähköpostiosoite",
    password: "Lösenord",
    sign_in_button: "Logga in",
    logout: "Logga ut",
    to_list: "Listanäkymä",
    to_calendar: "Kalenterinäkymä",
    today: "Tänään",
    month: "Kuukausi",
    week: "Viikko",
    day: "Päivä",
    do_signup: "Ilmoittaudu",
    event_details: "Lisätiedot",
    signed_up: "Ilmoittautumiset",
    owner_group: "Vastuuryhmä",
    name: "Namn",
    coming: "Tulen",
    not_coming: "En pääse",
    start_time: "Alkuaika",
    end_time: "Loppuaika",
    comments: "Kommentit",
    confirmed: "Vahvistettu",
    confirm: "Vahvista",
    leader: "Johtaja",
    trainee: "Harjoittelija",
    next_event: "Seuraava päivystyksesi",
    next_practice: "Seuraava ryhmäiltasi",
    mileage: "Matkakulut",
    explanation: "Matkaselvitys",
    add_to_calendar: "Lisää kalenteriin",
    log_entry: "Asiakaskirjaus",
    log_entries: "Asiakaskirjaukset",
    add_log_entry: "Lisää asiakaskirjaus",
    sex: "Sukupuoli",
    male: "Mies",
    female: "Nainen",
    sex_other: "Muu",
    wont_tell: "Ei kerro",
    age: "Ikä",
    adult: "Aikuinen",
    youth: "Nuori",
    child: "Lapsi",
    reason: "Tulosyy",
    reason_detail: "Tarkenne",
    firstaid: "Ensiapu",
    future_steps: "Kotihoito-ohjeet",
    next_step: "Jatkohoito",
    medicine_ok: "Ei estettä lääkkeelle",
    form_written: "Saate",
    other_notes: "Muuta",
    usage: "Tarvikkeet",
    log_user: "Kirjaaja",
    log_time: "Aika",
    event_log_entry: "Tapahtumakirjaus",
    event_log_entries: "Tapahtumakirjaukset",
    add_event_log_entry: "Lisää tapahtumakirjaus",
    entry: "Kirjaus",
    entry_number: "Asiakas nro",
    close: "Sulje",
    save: "Talleta",
    group: "Ryhmä",
    filter: "Suodata",
    all: "Kaikki",
    events: "Päivystykset",
    practices: "Ryhmäillat",
    trainings: "Koulutukset",
    others: "Muut",
    event_admin: "Hallinta",
    send_message: "Lähetä viesti",
    message_subject: "Viestin otsikko",
    default_message_subject: "Hupsis - Lisätietoviesti tapahtumasta",
    add_attachments: "Lisää liitetiedostoja",
    all_signedup: "Kaikille ilmoittautuneille",
    all_confirmed: "vahvistetuille",
    all_nonconfirmed: "vahvistamattomille",
    operation_code: "Operaation koodi",
    team_id: "Partion nimi",
  }
})

